import { Button, Divider, Grid, List, ListItem, Typography } from '@mui/material'
import { Box, Stack } from '@mui/system'
import React from 'react'
import { Item } from './snippets'
import '../../App.css'
import '../../css/modal.scss'
import DropDownOA from './dropDownOA'
import VisibilityIcon from '@mui/icons-material/Visibility'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore'
import * as error from './error_strings'
import { useState } from 'react'
import { activeClassForDashBoard, clickElement } from './helper'
import { connect } from 'react-redux'
import { useEffect } from 'react'
const Dashboard = ({ data, setDashboardOpen, handleAlert, Type, DashboardData }) => {
  const { common } = data
  const { cnsgnmntTypes, strtBrnch,companySettings } = { ...common }
  const UseToPayAsCOD=companySettings[0]?.UseToPayAsCOD
  const ViewASData = [
    { id: 1, viewName: 'LR Amount' },
    { id: 2, viewName: 'Units' },
  ]
  const [branchwiseInput, setBranchWiseInput] = useState(false)
  const [deliverywiseInput, setDeliveryWiseInput] = useState(false)
  const [dastStateId, setDastStateId] = useState(0)
  const [dastCityLiId, setDastCityLiId] = useState(0)
  const [selectedpayment, setSelectedPayment] = useState('')
  const [showDashData, setShowDashData] = useState(false)
  const [selectedRadio, setSelectedRadio] = useState('Booking Branch Wise')
  const [selectedConsignment, setSelectedConsignment] = useState('')
  const [selectedView, setSelectedView] = useState({ id: 1, viewName: 'LR Amount' })
  const [totalAmt, setTotalAmt] = useState({
    stateTotal: 0,
    cityTotal: 0,
    branchTotal: 0,
  })
  const [paymentTypeData, setPaymentTypeData] = useState([])
  const [cnsgnmntTypeData, setCnsgnmntTypeData] = useState([])
  const [branchesData, setBranchesData] = useState([])
  const [citiesData, setCitiesData] = useState([])
  const [stateData, setStateData] = useState([])
  const { stateTotal, cityTotal, branchTotal } = totalAmt
  const GroupData = (array, byGroup) => {
    if (array.length >= 1) {
      var newData = {}
      array?.forEach((item) => {
        if (!(item[byGroup] in newData)) {
          newData[item[byGroup]] = []
        }
        newData[item[byGroup]].push({
          lrno: item['lrno'],
          BookingBranch: item['BookingBranch'],
          BookingCity: item['BookingCity'],
          BookingState: item['BookingState'],
          BookingStateID: item['BookingStateID'],
          ConsignmentSubType: item['ConsignmentSubType'],
          ConsignmentSubTypeID: item['ConsignmentSubTypeID'],
          DestinationBranch: item['DestinationBranch'],
          DestinationCity: item['DestinationCity'],
          DestinationState: item['DestinationState'],
          DestinationStateID: item['DestinationStateID'],
          PaymentType: item['PaymentType'],
          PaymentTypeID: item['PaymentTypeID'],
          Units: item['Units'],
          bookingbranchid: item['bookingbranchid'],
          bookingcityid: item['bookingcityid'],
          destinationbranchid: item['destinationbranchid'],
          destinationcityid: item['destinationcityid'],
          NetAmount: item['NetAmount'],
        })
      })
      let NetAmountTotal = 0
      let index = 1
      Object.keys(newData)?.map((val) => {
        newData[val].forEach((val) => {
          if (selectedView.viewName === 'LR Amount' || selectedView === '') {
            NetAmountTotal += Number(val.NetAmount)
          } else {
            NetAmountTotal += Number(val.Units)
          }
        })
        if (byGroup === 'BookingState' || byGroup === 'DestinationState') {
          newData[val]?.unshift({
            BookingBranch: ` Total`,
            NetAmount: Number(NetAmountTotal.toFixed(2).toLocaleString('en-IN')),
            stateName: val,
            stateId: byGroup == 'BookingState' ? newData[val][0].BookingStateID : newData[val][0].DestinationStateID,
          })
        } else if (byGroup === 'BookingCity' || byGroup === 'DestinationCity') {
          newData[val]?.unshift({
            BookingBranch: ` Total`,
            NetAmount: Number(NetAmountTotal.toFixed(2).toLocaleString('en-IN')),
            CityName: val,
            CityId: byGroup == 'BookingCity' ? newData[val][0].bookingcityid : newData[val][0].destinationcityid,
          })
        } else if (byGroup === 'BookingBranch' || byGroup === 'DestinationBranch') {
          newData[val]?.unshift({
            BookingBranch: ` Total`,
            NetAmount: Number(NetAmountTotal.toFixed(2).toLocaleString('en-IN')),
            BranchName: val,
            BranchId: byGroup == 'BookingBranch' ? newData[val][0].bookingbranchid : newData[val][0].destinationbranchid,
          })
        }

        index += 1
        NetAmountTotal = 0
      })

      const mainData = { ...newData }
      let bodyData = []
      Object.keys(mainData)?.map((item) => {
        const data = [...bodyData]
        bodyData = [...data, ...mainData[item]]
      })
      const originalData = bodyData.filter((val, i) => Object.keys(val).length === 4)
      const sortedData = originalData.sort((p1, p2) => (p1.NetAmount < p2.NetAmount ? 1 : p1.NetAmount > p2.NetAmount ? -1 : 0))
      const confirmdata = sortedData.map((val, i) => ({ ID: i + 1, ...val }))
      if (byGroup === 'BookingState' || byGroup === 'DestinationState') {
        setStateData(confirmdata)
      } else if (byGroup === 'BookingCity' || byGroup === 'DestinationCity') {
        setCitiesData(confirmdata)
      } else if (byGroup === 'BookingBranch' || byGroup === 'DestinationBranch') {
        setBranchesData(confirmdata)
      }
    } else {
      if (byGroup === 'BookingState' || byGroup === 'DestinationState') {
        setStateData([])
      } else if (byGroup === 'BookingCity' || byGroup === 'DestinationCity') {
        setCitiesData([])
      } else if (byGroup === 'BookingBranch' || byGroup === 'DestinationBranch') {
        setBranchesData([])
      }
    }
  }

  //for unique paymenttype and consignment type
  useEffect(() => {
    if (DashboardData?.status === true) {
      setBranchWiseInput(true)
      setShowDashData(true)
      if (DashboardData?.Data?.Table?.length >= 1) {
        const unique = new Set()
        const PaymentType = DashboardData?.Data?.Table?.map((val) => ({ name: val.PaymentType, typeId: val.PaymentTypeID }))
        const uniquePaymentType = PaymentType?.filter((ele) => {
          const isDuplicate = unique.has(ele.typeId)
          unique.add(ele.typeId)
          if (!isDuplicate) {
            return true
          }
          return false
        })
        const ItemType = DashboardData?.Data?.Table?.map((val) => ({
          SubType: val.ConsignmentSubType,
          ConsignmentSubTypeID: val.ConsignmentSubTypeID,
        }))
        const uniqueItemType = ItemType?.filter((ele) => {
          const isDuplicate = unique.has(ele.ConsignmentSubTypeID)
          unique.add(ele.ConsignmentSubTypeID)
          if (!isDuplicate) {
            return true
          }
          return false
        })
        const obj={
          SubType:"All" ,
          ConsignmentSubTypeID:0,
        }
        setPaymentTypeData(uniquePaymentType)
        setCnsgnmntTypeData([obj,...uniqueItemType])
      } else {
        setPaymentTypeData([])
        setCnsgnmntTypeData([])
      }
    }
  }, [DashboardData])
  //for first selected
  useEffect(() => {
    if (DashboardData?.status === true) {
      document?.getElementById('firstDashStateItem')?.click()
    }
  }, [stateData])
  useEffect(() => {
    if (DashboardData?.status === true) {
      document?.getElementById('firstDashCityItem')?.click()
    }
  }, [citiesData])

  useEffect(() => {
    setBranchWiseInput(true)
    setShowDashData(true)
    if (DashboardData?.status === true) {
      const StateTotal = DashboardData?.Data?.Table?.map((item) => item?.NetAmount).reduce((partialSum, a) => partialSum + a, 0)
      setTotalAmt({
        ...totalAmt,
        stateTotal: StateTotal.toFixed(2).toLocaleString('en-IN'),
      })
      GroupData(DashboardData?.Data?.Table, 'BookingState')
      setDastStateId(1)
    }
  }, [DashboardData])

  const filterData = (arr) => {
    return arr.filter(
      (item) =>
        (selectedpayment ? item.PaymentTypeID === selectedpayment?.typeId : item.PaymentTypeID !== selectedpayment?.typeId) &&
        (selectedConsignment
          ? item.ConsignmentSubTypeID === selectedConsignment.ConsignmentSubTypeID
          : item.ConsignmentSubTypeID !== selectedConsignment?.ConsignmentSubTypeID)
    )
  }
  const selectedStateItem = (item) => {
    setDastStateId(item.ID)
    setDastCityLiId(0)
    setBranchesData([])
    const filteredData = filterData(DashboardData?.Data?.Table)
    if (selectedRadio === 'Booking Branch Wise') {
      const data = filteredData.filter((val) => val.BookingStateID === item.stateId)
      let CityTotal = 0
      if (selectedView.viewName === 'LR Amount' || selectedView === '') {
        CityTotal = data?.map((item) => item.NetAmount).reduce((partialSum, a) => partialSum + a, 0)
      } else {
        CityTotal = data?.map((item) => item.Units).reduce((partialSum, a) => partialSum + a, 0)
      }
      setTotalAmt({
        ...totalAmt,
        cityTotal: CityTotal.toFixed(2).toLocaleString('en-IN'),
      })
      GroupData(data, 'BookingCity')
    } else {
      const data = filteredData.filter((val) => val.DestinationStateID === item.stateId)
      let CityTotal = 0
      if (selectedView.viewName === 'LR Amount' || selectedView === '') {
        CityTotal = data?.map((item) => item.NetAmount).reduce((partialSum, a) => partialSum + a, 0)
      } else {
        CityTotal = data?.map((item) => item.Units).reduce((partialSum, a) => partialSum + a, 0)
      }
      setTotalAmt({
        ...totalAmt,
        cityTotal: CityTotal.toFixed(2).toLocaleString('en-IN'),
      })
      GroupData(data, 'DestinationCity')
    }
  }

  const selectedCityItem = (item) => {
    const filteredData = filterData(DashboardData?.Data?.Table)
    setDastCityLiId(item.ID)
    if (selectedRadio === 'Booking Branch Wise') {
      const data = filteredData.filter((val) => val.bookingcityid === item.CityId)
      let branchTotal = 0
      if (selectedView.viewName === 'LR Amount' || selectedView === '') {
        branchTotal = data?.map((item) => item.NetAmount).reduce((partialSum, a) => partialSum + a, 0)
      } else {
        branchTotal = data?.map((item) => item.Units).reduce((partialSum, a) => partialSum + a, 0)
      }
      setTotalAmt({
        ...totalAmt,
        branchTotal: branchTotal.toFixed(2).toLocaleString('en-IN'),
      })
      GroupData(data, 'BookingBranch')
    } else {
      const data = filteredData.filter((val) => val.destinationcityid === item.CityId)
      let branchTotal = 0
      if (selectedView.viewName === 'LR Amount' || selectedView === '') {
        branchTotal = data?.map((item) => item.NetAmount).reduce((partialSum, a) => partialSum + a, 0)
      } else {
        branchTotal = data?.map((item) => item.Units).reduce((partialSum, a) => partialSum + a, 0)
      }
      setTotalAmt({
        ...totalAmt,
        branchTotal: branchTotal.toFixed(2).toLocaleString('en-IN'),
      })
      GroupData(data, 'DestinationBranch')
    }
  }
  const buttonClick = (id) => {
    switch (id) {
      case 'Go':
        setSelectedView('')
        setTotalAmt({
          ...totalAmt,
          stateTotal: 0,
          cityTotal: 0,
          branchTotal: 0,
        })
        if (selectedRadio === '') {
          handleAlert(error.SELECT_RECEIVE_DASH_Branch)
        } else {
          setSelectedView({ id: 1, viewName: 'LR Amount' })
          if (DashboardData?.status === true) {
            const StateTotal = DashboardData?.Data?.Table?.map((item) => item?.NetAmount).reduce((partialSum, a) => partialSum + a, 0)
            setTotalAmt({
              ...totalAmt,
              stateTotal: StateTotal.toFixed(2).toLocaleString('en-IN'),
            })
            GroupData(DashboardData?.Data?.Table, selectedRadio === 'Booking Branch Wise' ? 'BookingState' : 'DestinationState')
            setDastStateId(0)
            setShowDashData(true)
          } else {
            handleAlert('No Data Found')
          }
        }
        break
      case 'Apply':
        const filteredData = filterData(DashboardData?.Data?.Table)
        if (filteredData.length > 0) {
          if (selectedRadio === 'Booking Branch Wise') {
            let StateTotal = 0
            if (selectedView.viewName === 'LR Amount' || selectedView === '') {
              StateTotal = filteredData.map((item) => item.NetAmount).reduce((partialSum, a) => partialSum + a, 0)
            } else {
              StateTotal = filteredData.map((item) => item.Units).reduce((partialSum, a) => partialSum + a, 0)
            }
            setTotalAmt({
              ...totalAmt,
              stateTotal: StateTotal.toFixed(2).toLocaleString('en-IN'),
            })
            setBranchesData([])
            setCitiesData([])
            setDastStateId(0)
            setDastCityLiId(0)
            GroupData(filteredData, 'BookingState')
          } else {
            let StateTotal = 0
            if (selectedView.viewName === 'LR Amount' || selectedView === '') {
              StateTotal = filteredData.map((item) => item.NetAmount).reduce((partialSum, a) => partialSum + a, 0)
            } else {
              StateTotal = filteredData.map((item) => item.Units).reduce((partialSum, a) => partialSum + a, 0)
            }
            setTotalAmt({
              ...totalAmt,
              stateTotal: StateTotal.toFixed(2).toLocaleString('en-IN'),
            })
            setDastStateId(0)
            setDastCityLiId(0)
            setBranchesData([])
            setCitiesData([])
            GroupData(filteredData, 'DestinationState')
          }
        } else {
          setDastStateId(0)
          setDastCityLiId(0)
          setBranchesData([])
          setStateData([])
          setCitiesData([])
          handleAlert('No Data Found')
        }
        break
    }
  }

  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    nextArrow: <ChevronRightIcon />,
    prevArrow: <NavigateBeforeIcon />,
  }

  return (
    <>
      <Stack direction="row" spacing={2} sx={{ background: '#f0fcf4', width: '100%', marginTop: '10px' }}>
        <Item sx={{ width: '100%', paddingTop: '16px', background: '#f0fcf4' }}>
          <Box className="DashboardTop">
            <span>
              Pending{' '}
              {Type === 'Receive'
                ? 'Receive'
                : Type === 'BranchReceive'
                ? 'Transfer Receive'
                : Type === 'BranchTransfer'
                ? 'Transfer'
                : Type === 'Dispatch'
                ? 'Dispatch'
                : ''}{' '}
              Analysis:
            </span>
            <input
              type="radio"
              name="dashRadio"
              checked={branchwiseInput}
              onChange={() => {
                setSelectedRadio('Booking Branch Wise')
                setShowDashData(false)
                setCitiesData([])
                setBranchesData([])
                setSelectedView(ViewASData?.[0])
                setSelectedPayment('')
                setSelectedConsignment('')
                setBranchWiseInput(true)
                setDeliveryWiseInput(false)
              }}
            />
            <span>Booking Branch Wise</span>
            <input
              type="radio"
              name="dashRadio"
              checked={deliverywiseInput}
              onChange={() => {
                setSelectedRadio('Delivery Branch Wise')
                setShowDashData(false)
                setCitiesData([])
                setBranchesData([])
                setSelectedView(ViewASData?.[0])
                setSelectedPayment('')
                setSelectedConsignment('')
                setBranchWiseInput(false)
                setDeliveryWiseInput(true)
              }}
            />
            <span>Delivery Branch Wise</span>
            <Button
              variant="contained"
              style={{
                width: '25px',
                height: '25px',
                marginLeft: '17px',
                backgroundColor: '#FE5200',
                fontSize: '12px',
                textTransform: 'Uppercase',
                color: '#fff',
                fontWeight: 'bold',
              }}
              onClick={() => buttonClick('Go')}
            >
              GO
            </Button>
            <span className="secondSpan" onClick={() => setDashboardOpen(false)}>
              {' '}
              <b>X</b> Close Dashboard
            </span>
          </Box>
        </Item>
      </Stack>
      {showDashData ? (
        <>
          <Stack direction="row" spacing={2} className="stack-wrapper">
            <Grid container>
              <Grid item xs={7} className={paymentTypeData?.length >= 8 ? 'dashboard-payment' : 'dashboard-payment1'}>
                <Slider {...settings}>
                  {paymentTypeData.map(item => {
                      if (UseToPayAsCOD === 1) {
                        if (item.typeId === 2) return { ...item, name: 'COD' };
                        if (item.typeId === 7) return { ...item, name: 'COD(MANUAL)' };
                      }
                      return item;
                    }).filter(item => !(UseToPayAsCOD === 1 && item.typeId === 4) && item.typeId !== 0)
                    .map((val,i) => (
                      <span
                        className={
                          val.typeId === selectedpayment?.typeId
                            ? 'selected-pay activePaymentList'
                            : activeClassForDashBoard(val.name)
                        }
                        onClick={() => setSelectedPayment(val)}
                        key={i+"22e2cs"}
                      >
                        {val.name}
                      </span>
                    ))}
                </Slider>
              </Grid>

              <Grid item xs={5} className="dashboard-buttons">
                <FilterAltIcon className="filter-icon" />
                <Box style={{ display: 'flex' }}>
                  <DropDownOA
                    data={cnsgnmntTypeData || []}
                    width="60%"
                    dataKey={`SubType`}
                    defaultvalue="All"
                    isObjArr={true}
                    idKey={`ConsignmentSubTypeID`}
                    searchPlaceholder={`Search Consignment Type`}
                    label={'Consignment Type'}
                    onSelect={(value) => value.SubType==="All"? setSelectedConsignment(null): setSelectedConsignment(value)}
                  />
                  <VisibilityIcon className="icon" />
                  <DropDownOA
                    data={ViewASData || []}
                    isObjArr={true}
                    defaultvalue={selectedView?.viewName}
                    idKey={`id`}
                    dataKey={`viewName`}
                    searchPlaceholder={`Search View`}
                    label={'View As'}
                    onSelect={(value) => setSelectedView(value)}
                  />
                  <Button
                    onClick={(e) => buttonClick('Apply')}
                    variant="contained"
                    sx={{ width: '100%' }}
                    style={{ backgroundColor: '#fe5200', fontSize: '15px', textTransform: 'Uppercase', color: '#fff', fontWeight: 'bold' }}
                  >
                    Apply
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Stack>
          <Stack
            direction="row"
            spacing={2}
            className="dash-bottum"
            divider={
              <Divider
                orientation="vertical"
                sx={{
                  width: '1px',
                  margin: '0px 0px 0px 0px !important',
                  backgroundColor: '#DDD',
                }}
                flexItem
              />
            }
          >
            <Item className="dash-bottum-grid">
              <Typography variant="h3" className="dash-hedding">
                {selectedRadio === 'Booking Branch Wise' ? ' Booking State' : ' Destination State'}
              </Typography>
              <List className={Type === 'BranchTransfer' || Type === 'Dispatch' ? 'smallul' : ''}>
                {stateData?.map((val, i) => {
                  return (
                    <ListItem
                      disablePadding
                      key={i+"132wqa"}
                      id={i == 0 ? 'firstDashStateItem' : i}
                      className={val.ID === dastStateId ? 'selected-Item' : ''}
                      onClick={() => selectedStateItem(val)}
                    >
                      <Typography variant="body1" className="states-name" title={val.stateName}>
                        {val.stateName}
                      </Typography>

                      <Box className="dash-amount">
                        <Typography variant="body1" className="amount" title={val.NetAmount.toLocaleString('en-IN')}>
                          {val.NetAmount.toLocaleString('en-IN')}
                        </Typography>
                        <Box className="progress-bar">
                          <Box
                            className="progress"
                            style={{ width: `${val.NetAmount == 0 ? 0 : ((val.NetAmount * 100) / stateTotal).toFixed(2)}%` }}
                          >
                            <span className="progress-text">
                              {val.NetAmount == 0 ? 0 : ((val.NetAmount * 100) / stateTotal).toFixed(2)}%
                            </span>
                          </Box>
                        </Box>
                      </Box>

                      <ChevronRightIcon className="dash-mid-right-icon" />
                    </ListItem>
                  )
                })}
              </List>
            </Item>
            <Item className="dash-bottum-grid">
              <Typography variant="h3" className="dash-hedding">
                {selectedRadio === 'Booking Branch Wise' ? ' Booking Cities' : ' Destination Cities'}
              </Typography>
              <List className={Type === 'BranchTransfer' || Type === 'Dispatch' ? 'smallul' : ''}>
                {citiesData?.map((val, i) => {
                  return (
                    <ListItem
                      disablePadding
                      key={i+'3we3r21'}
                      id={i == 0 ? 'firstDashCityItem' : i}
                      className={val.ID === dastCityLiId ? 'selected-Item' : ''}
                      onClick={() => selectedCityItem(val)}
                    >
                      <Typography variant="body1" className="states-name" title={val.CityName}>
                        {val.CityName}
                      </Typography>

                      <Box className="dash-amount">
                        <Typography variant="body1" className="amount" title={val.NetAmount.toLocaleString('en-IN')}>
                          {val.NetAmount.toLocaleString('en-IN')}
                        </Typography>
                        <Box className="progress-bar">
                          <Box
                            className="progress"
                            style={{ width: `${val.NetAmount == 0 ? 0 : ((val.NetAmount * 100) / cityTotal).toFixed(2)}%` }}
                          >
                            <span className="progress-text">
                              {val.NetAmount == 0 ? 0 : ((val.NetAmount * 100) / cityTotal).toFixed(2)}%
                            </span>
                          </Box>
                        </Box>
                      </Box>

                      <ChevronRightIcon className="dash-mid-right-icon" />
                    </ListItem>
                  )
                })}
              </List>
            </Item>
            <Item className="dash-bottum-grid">
              <Typography variant="h3" className="dash-hedding">
                {selectedRadio === 'Booking Branch Wise' ? ' Booking Branches' : ' Destination Branches'}
              </Typography>
              <List className={Type === 'BranchTransfer' || Type === 'Dispatch' ? 'smallul' : ''}>
                {branchesData?.map((val, i) => {
                  return (
                    <ListItem disablePadding id={i} className={val.BranchId === strtBrnch?.BranchID ? 'selected-Branch' : ''} key={i+'124qwes54t'}>
                      <Typography variant="body1" className="states-name" title={val.BranchName}>
                        {val.BranchName}
                      </Typography>

                      <Box className="dash-amount">
                        <Typography variant="body1" className="amount" title={val.NetAmount.toLocaleString('en-IN')}>
                          {val.NetAmount.toLocaleString('en-IN')}
                        </Typography>
                        <Box className="progress-bar">
                          <Box
                            className="progress"
                            style={{ width: `${val.NetAmount == 0 ? 0 : ((val.NetAmount * 100) / branchTotal).toFixed(2)}%` }}
                          >
                            <span className="progress-text">
                              {val.NetAmount == 0 ? 0 : ((val.NetAmount * 100) / branchTotal).toFixed(2)}%
                            </span>
                          </Box>
                        </Box>
                      </Box>

                      <ChevronRightIcon className="dash-mid-right-icon-branch" />
                    </ListItem>
                  )
                })}
              </List>
            </Item>
          </Stack>
        </>
      ) : (
        ''
      )}
    </>
  )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)
